const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const YOUTUBE_HOSTS = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "music.youtube.com",
  "youtu.be",
]);

const parseYouTubeVideoId = (value = "") => {
  const input = String(value || "").trim();
  if (!input) return "";
  if (YOUTUBE_ID_PATTERN.test(input)) return input;

  try {
    const parsed = new URL(input);
    const host = parsed.hostname.toLowerCase().replace(/\.$/, "");
    if (parsed.protocol !== "https:" || !YOUTUBE_HOSTS.has(host)) return "";

    let videoId = "";
    if (host === "youtu.be") {
      videoId = parsed.pathname.split("/").filter(Boolean)[0] || "";
    } else if (parsed.pathname === "/watch") {
      videoId = parsed.searchParams.get("v") || "";
    } else {
      const [prefix, candidate] = parsed.pathname.split("/").filter(Boolean);
      if (["embed", "shorts", "live"].includes(prefix)) videoId = candidate || "";
    }
    return YOUTUBE_ID_PATTERN.test(videoId) ? videoId : "";
  } catch {
    return "";
  }
};

export const resolvePromotionYouTube = (promotion = {}) => {
  if (promotion?.mediaType !== "youtube" && !promotion?.youtube?.videoId) return null;
  const videoId = parseYouTubeVideoId(
    promotion?.youtube?.videoId || promotion?.youtube?.canonicalUrl,
  );
  if (!videoId) return null;
  return {
    videoId,
    embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}`,
    thumbnailUrl:
      promotion?.youtube?.thumbnailUrl ||
      `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
  };
};

export default resolvePromotionYouTube;
